<!--
/**
 * DjAccountReviewTab.vue - 开户审核查询 Tab 组件
 *
 * 【功能说明】
 * 本组件是迪加(DJ)虚拟商品管理系统的开户审核查询页面，
 * 用于查询指定号码的开户审核结果，展示认证手机号、审核状态、
 * 审核备注、审核时间、提交时间等信息。
 *
 * 【主要功能】
 * 1. 审核结果查询 - 根据手机号查询该号码的开户审核状态和结果
 *
 * 【权限要求】
 * - 所有用户：可查询审核结果
 -->
<template>
  <div>
    <!-- ========== 搜索区域 ========== -->
    <div class="handle-box">
      <!-- 号码输入框 -->
      <el-input size="small" v-model="phone" clearable maxlength="12" placeholder="号码"
                style="width: 180px;" class="handle-input mr10"></el-input>
      <!-- 搜索按钮 -->
      <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
                 @click="getauditResult">搜索
      </el-button>
    </div>

    <!-- ========== 审核结果信息展示（有数据时才显示） ========== -->
    <div class="table-box2" v-if="auditResultData">
      <!-- 认证手机号 -->
      <div class="user-info-box" style="min-width: 500px;">
        <div class="user-info-tit">账户信息</div>
        <div class="info-box">
          <div class="info-name">认证手机号：</div>
          <div class="info">{{ auditResultData.billId }}</div>
        </div>
      </div>
      <!-- 审核状态 -->
      <div class="user-info-box" style="min-width: 500px;">
        <div class="info-box">
          <div class="info-name">状态：</div>
          <div class="info">{{ auditResultData.status }}</div>
        </div>
      </div>
      <!-- 审核备注 -->
      <div class="user-info-box" style="min-width: 500px;">
        <div class="info-box">
          <div class="info-name">审核备注：</div>
          <div class="info">{{ auditResultData.auditMsg }}</div>
        </div>
      </div>
      <!-- 审核时间 -->
      <div class="user-info-box" style="min-width: 500px;">
        <div class="info-box">
          <div class="info-name">审核时间：</div>
          <div class="info">{{ auditResultData.auditDate }}</div>
        </div>
      </div>
      <!-- 提交时间 -->
      <div class="user-info-box" style="min-width: 500px;">
        <div class="info-box">
          <div class="info-name">提交时间：</div>
          <div class="info">{{ auditResultData.lastCommitDate }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 开户审核查询 Tab 组件脚本部分
 *
 * 引入的 API 接口：
 * - auditResult：查询开户审核结果
 */
import {
  auditResult
} from '../../../api/dijia.js';

export default {
  name: 'DjAccountReviewTab',

  /**
   * 【Props 接收的参数】
   * - theme：主题颜色样式类名
   */
  props: {
    theme: { type: String, default: '' },
  },

  data() {
    return {
      // ========== 查询相关 ==========
      loading: false,           // 加载状态
      phone: '',                // 搜索的手机号
      auditResultData: '',      // 审核结果数据对象（含billId, status, auditMsg, auditDate, lastCommitDate）
    };
  },

  methods: {
    /**
     * getauditResult - 查询开户审核结果
     * 根据手机号查询该号码的开户审核状态和详细信息
     * 查询前清空之前的结果数据
     */
    getauditResult() {
      this.auditResultData = '';
      let data = { phone: this.phone };
      this.loading = true;
      auditResult(data).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.auditResultData = res.data.content;
        } else {
          this.$message.error(res.message);
        }
      });
    },
  }
};
</script>

<style scoped>
@import './tab-styles.css';
</style>
